"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _reactJss = require("react-jss");

var _fonts = require("../../styles/fonts");

var _variables = require("../../styles/variables");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _reactJss.createUseStyles)(_objectSpread(_objectSpread({}, _fonts.fontStyles), {}, {
  div: function div(props) {
    return {
      display: "inline-block",
      borderRadius: props.size === 'lg' ? "10px" : "5px",
      overflow: "hidden",
      border: "1px solid ".concat(_variables.colors.hare)
    };
  },
  button: function button(props) {
    return {
      fontFamily: "IranSansX",
      backgroundColor: _variables.colors.ghost,
      color: _variables.colors.father,
      cursor: "pointer",
      borderRadius: "0",
      borderStyle: "none",
      outline: "none",
      fontSize: props.size === 'lg' ? "12px" : "10px",
      padding: "9px",
      lineHeight: props.size === 'lg' ? 2.4 : 1.6,
      minWidth: props.size === 'lg' ? "130px" : "auto",
      height: props.size === 'lg' ? "42px" : "auto",
      "&:focus": {
        outline: "0"
      },
      "&:active": {
        outline: "none"
      }
    };
  },
  buttonExtraSmall: {
    padding: "4px!important",
    minWidth: "25px!important",
    height: "26px!important",
    lineHeight: "2!important"
  },
  btnActive: {
    backgroundColor: "".concat(_variables.colors.father, " !important"),
    color: "".concat(_variables.colors.ghost, " !important")
  },
  btnInactive: {
    borderLeft: "1px solid ".concat(_variables.colors.hare),
    "&:first-child": {
      borderLeft: "none"
    }
  }
}), {
  name: 'pds-multiple-button'
});
exports.useStyles = useStyles;